// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3YVCX","requiredAsterisk":"Info_requiredAsterisk__33nxE"};